<template>
    <div style="position: relative;">
      
    </div>
</template>
<script>
import Footer from '../../components/Footer.vue'
export default {
    data() {
        return {

        }
    },
    components: {
        Footer
    },
    mounted() {
        
    },
}
</script>
<style lang="less" scoped>

</style>